import { useDocuparserHttp } from "./useDocuparserHttp";
import type { DocuparserClient } from "../services/docuparserApi";

/**
 * DocuParser is host-direct (no per-connector Cognito login/logout) — the
 * real client authenticates with the add-in's own AIVA session (see
 * hooks/useDocuparserHttp.ts) and talks to the DocuParser.Endpoints API
 * (AIVA-7127). Set VITE_DOCUPARSER_API_BASE_URL / __CONFIG__.DOCUPARSER_API_BASE_URL
 * to point at it.
 */
export function useDocuparserClient(): DocuparserClient {
  return useDocuparserHttp();
}
